var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"yt-square-sidebarItem"},[_c('button',[_c('div',{staticClass:"item"},[_c('div',{staticClass:"yt-icon"},[_c('img',{attrs:{"src":_vm.ytIcon,"alt":""}})]),_c('div',{staticClass:"textTitle"},[_c('p',[_vm._v(_vm._s(_vm.$t("page.youtube.leftSideBar." + this.text)))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }